import * as _ from 'lodash';
import { ODataModel, ODataObject } from '../../interfaces/odata-model.interface';
import { ModelOptions } from '../options/model-options';

export abstract class CompositeModel implements ODataModel {
    public value: { [name: string]: ODataModel } = {};
    public constructor(
        public name: string,
        public options?: ModelOptions,
    ) {}

    /**
     * Iterate over internal models object and call outmodel conversion function for each of the models
     *
     * @returns {object} the outmodel representation of this complex model
     */
    public getOutModel(): ODataCompositeOutModel {
        const outModel: ODataCompositeOutModel = {};
        for (const child in this.value) {
            if (!this.value.hasOwnProperty(child)) {
                continue;
            }

            // get outModel of child model
            const childOutModel = this.value[child].getOutModel();

            // copy properties of child model into outModel
            _.merge(outModel, childOutModel);
        }
        return outModel;
    }

    /**
     * Set child model in internal models object
     *
     * @param model the model to be added
     */
    public set(model: ODataModel): ODataModel {
        // add model to internal models object
        this.value[model.name] = model;
        return this.value[model.name];
    }

    /**
     * Get child model from internal models object
     *
     * @param name
     * @returns {ODataModel}
     */
    public get(name: string): ODataModel {
        return this.value[name];
    }
}

// need here type because empty interfaces are not allowed
export type ODataCompositeOutModel = ODataObject;
